import React from 'react';
import PropTypes from 'prop-types';
import PersonIcon from 'material-ui/svg-icons/social/person';
import CompanyIcon from 'material-ui/svg-icons/social/location-city';
import CreditCardIcon from 'material-ui/svg-icons/action/credit-card';

import NavLink from '../nav-link';

const SettingsLeftNav = (props) => {
  const { user: { userType, company }, className } = props;
  const billingEnabled = company.billingEnabled;
  const companySettings = [
    { text: 'Manage Users', anchorId: 'manage-users' },
    { text: 'Associated Emails', anchorId: 'secondary-emails' },
  ];
  if (userType === 'Contractor') {
    companySettings.push({ text: 'Forwarding Address', anchorId: 'emailForwarding' });
    companySettings.push({ text: 'Contract Settings', anchorId: 'contracting-settings' });
  }
  const navItems = [{
    icon: <PersonIcon color="rgba(0, 0, 0, 0.54)" />,
    heading: 'My Settings',
    items: [
      { text: 'Personal Details', anchorId: 'personalDetails' },
      { text: 'Access Level', anchorId: 'accessLevel' },
      { text: 'Notifications', anchorId: 'notifications' },
      { text: 'Rate Format', anchorId: 'rateFormat' },
    ],
  }, {
    icon: <CompanyIcon color="rgba(0, 0, 0, 0.54)" />,
    heading: 'Company Settings',
    items: companySettings,
  }];
  if (billingEnabled) {
    navItems.push({
      icon: <CreditCardIcon color="rgba(0, 0, 0, 0.54)" />,
      heading: 'Billing Settings',
      items: [
        { text: 'Billing', anchorId: 'billing' },
      ],
    });
  }
  return (
    <div className={className} style={{ marginTop: '-65px' }}>
      <div className="settings-left-nav-inner">
        {
          navItems.map(obj => ([
            <div key="heading" className="settings-left-nav-heading flex-center">
              {obj.icon}
              {obj.heading}
            </div>,
            <div key="widget" className="connections-widget">
              {
                obj.items.map(setting => (
                  <NavLink
                    key={setting.anchorId}
                    {...props}
                    classes="nav-link connections-widget-link"
                    activeRoutes={[]}
                    routeName={`/settings/${setting.anchorId}`}
                  >
                    {setting.text}
                  </NavLink>
                ))
              }
            </div>,
          ]))
        }
      </div>
    </div>
  );
};

SettingsLeftNav.propTypes = {
  className: PropTypes.string,
  user: PropTypes.object,
  billing: PropTypes.object,
};

export default SettingsLeftNav;



// WEBPACK FOOTER //
// ./src/app/components/settings/settings-left-nav.jsx